/**
 * Canonical, repository-owned business contact information.
 *
 * Do not duplicate these values in components or schema. Operational details
 * (especially coverage and hours) must be confirmed by the business owner
 * before they are changed here.
 */
export const business = {
  name: 'TourMy.co',
  legalName: 'TourMy.co',
  siteUrl: 'https://tourmy.co',
  phone: {
    display: '(440) 785-8846',
    e164: '+14407858846',
    href: 'tel:+14407858846',
    smsHref: 'sms:+14407858846',
  },
  email: 'hello@tourmy.co',
  emailHref: 'mailto:hello@tourmy.co',
  base: {
    locality: 'Nashville',
    region: 'TN',
    country: 'US',
  },
  operatingRegions: ['Northeast Ohio', 'Nashville and Middle Tennessee'],
  serviceAreas: {
    northeastOhio: ['Cleveland', 'Akron', 'Canton'],
    middleTennessee: ['Nashville', 'Franklin', 'Murfreesboro'],
  },
  businessHours: null,
  social: {
    facebook: 'https://www.facebook.com/tourmy.co',
    instagram: 'https://www.instagram.com/tourmy.co',
    linkedin: 'https://www.linkedin.com/company/tourmy-co',
  },
  scheduling: {
    consultation: 'https://calendly.com/hello-tourmy/30min',
    quickCall: 'https://calendly.com/hello-tourmy/10min',
  },
  copyrightYear: new Date().getFullYear(),
} as const;

export type BusinessConfig = typeof business;
